import React from 'react'
import { ParamGroup } from './ParamTree'
import AppDialog from 'components/AppDialog'
import { ParamConfigEdit } from './ParamConfigEdit'
interface Props {
	configDataDetail?: ParamGroup[]
	scope: number
	afterSave: () => void
}
export const ParamConfigGroups = (props: Props) => {
	const addParamConfig = (data: any) => {
		AppDialog.open(<ParamConfigEdit scope={props.scope} paramConfigGroup={data} afterSave={props.afterSave} />, {
			title: '新增参数',
			size: 'full',
		})
	}
	const renderFormBlock = () => {
		return props.configDataDetail.map((v, k) => {
			return (
				<div key={k}>
					{/* <AppFormBlock key={k} title={v.paramGroup.showName} >
                        {v.paramList.map((vv,kk)=>{
                            if(vv.scope===props.scope){
                                switch(vv.type){
                                    case 0: // 文本类输入
                                    return <AppFormInput
                                                key ={kk}
                                                label={vv.showName}
                                                dataType="string"
                                                field={vv.keyName}
                                            />
                                    case 1: // 数值类输入
                                    return <AppFormInput
                                                key ={kk}
                                                label={vv.showName}
                                                field={vv.keyName}
                                                dataType="number"
                                                />
                                    case 2: // 日期类输入
                                        return <AppFormDate
                                                key ={kk}
                                                label={vv.showName}
                                                field={vv.keyName}
                                            />
                                    default: // 单选
                                        return <AppFormRadio
                                                key ={kk}
                                                label={vv.showName}
                                                field={vv.keyName}
                                                appFormItemOptionList={vv.appConfigParamOptionList.map((e:any)=>{
                                                    return {
                                                        label:e.text,
                                                        value:e.value
                                                    }
                                                })}
                                            />
                            }
                            }else{
                                return null
                            }
                        })}
                    </AppFormBlock>  */}
					<div style={{ display: 'flex', justifyContent: 'center' }}>
						<span
							className="app-button"
							style={{ height: '29px' }}
							data-type="primary"
							onClick={() => addParamConfig(v.paramGroup)}
						>
							新增参数
						</span>
					</div>
				</div>
			)
		})
	}
	return (
		<div className="app-dialog-form-container">
			<div className="app-dialog-form">
				{/* <AppForm formStyle={{ width: '100%' }} labelWidth={100}>
					{renderFormBlock()}
				</AppForm> */}
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/modules/modeling/param/components/ParamConfigGroups.tsx